// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BLuSv","description":"styles_description__Uydun"};